import { Dispatch } from 'redux';
import { setCaseIsWriteable, setCaseIsReadonly } from 'modules/cm/store/cases/permission/actions';

const caseViewPermissionChange = (havePermissionToWrite: boolean) => {
  return async (dispatch: Dispatch) => {
    if (havePermissionToWrite) {
      dispatch(setCaseIsWriteable());
    } else {
      dispatch(setCaseIsReadonly());
    }
  };
};

export { caseViewPermissionChange };
